export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/admin',
    /* internal name: '/admin' */
    /* no component */
    children: [
      {
        path: 'bulk-extension',
        name: '/admin/bulk-extension',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/bulk-extension.vue'),
        /* no children */
      },
      {
        path: 'campaign',
        name: '/admin/campaign',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/campaign.vue'),
        /* no children */
      },
      {
        path: 'create-user',
        name: '/admin/create-user',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/create-user.vue'),
        /* no children */
      },
      {
        path: 'extension',
        name: '/admin/extension',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/extension.vue'),
        /* no children */
      },
      {
        path: 'feature-users',
        name: '/admin/feature-users',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/feature-users.vue'),
        /* no children */
      },
      {
        path: 'maintenance',
        name: '/admin/maintenance',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/maintenance.vue'),
        /* no children */
      },
      {
        path: 'notification',
        name: '/admin/notification',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/notification.vue'),
        /* no children */
      },
      {
        path: 'parser-analytics',
        name: '/admin/parser-analytics',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/parser-analytics.vue'),
        /* no children */
      },
      {
        path: 'stats',
        /* internal name: '/admin/stats' */
        /* no component */
        children: [
          {
            path: 'bet-limit',
            name: '/admin/stats/bet-limit',
            component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/stats/bet-limit.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'survey',
        name: '/admin/survey',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/survey.vue'),
        /* no children */
      },
      {
        path: 'telegram-usage',
        name: '/admin/telegram-usage',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/telegram-usage.vue'),
        /* no children */
      },
      {
        path: 'user-devices',
        name: '/admin/user-devices',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/admin/user-devices.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/appearance',
    name: '/appearance',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/appearance.vue'),
    /* no children */
  },
  {
    path: '/bet-types',
    name: '/bet-types',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/bet-types.vue'),
    /* no children */
  },
  {
    path: '/calculate-v2',
    name: '/calculate-v2',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/calculate-v2.vue'),
    /* no children */
  },
  {
    path: '/customers',
    /* internal name: '/customers' */
    /* no component */
    children: [
      {
        path: 'form',
        name: '/customers/form',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/customers/form.vue'),
        /* no children */
      },
      {
        path: 'limits',
        name: '/customers/limits',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/customers/limits.vue'),
        /* no children */
      },
      {
        path: 'list',
        name: '/customers/list',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/customers/list.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/drafts',
    name: '/drafts',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/drafts.vue'),
    /* no children */
  },
  {
    path: '/guide',
    name: '/guide',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/guide.vue'),
    /* no children */
  },
  {
    path: '/inquiry',
    name: '/inquiry',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/inquiry.vue'),
    /* no children */
  },
  {
    path: '/limit',
    /* internal name: '/limit' */
    /* no component */
    children: [
      {
        path: '',
        name: '/limit/',
        component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/limit/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/lottery',
    name: '/lottery',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/lottery.vue'),
    /* no children */
  },
  {
    path: '/maintenance',
    name: '/maintenance',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/maintenance.vue'),
    /* no children */
  },
  {
    path: '/manager',
    name: '/manager',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/manager.vue'),
    /* no children */
  },
  {
    path: '/manager2',
    name: '/manager2',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/manager2.vue'),
    /* no children */
  },
  {
    path: '/manager3',
    name: '/manager3',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/manager3.vue'),
    /* no children */
  },
  {
    path: '/notification',
    name: '/notification',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/notification.vue'),
    /* no children */
  },
  {
    path: '/password',
    name: '/password',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/password.vue'),
    /* no children */
  },
  {
    path: '/report',
    name: '/report',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/report.vue'),
    /* no children */
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/station',
    name: '/station',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/station.vue'),
    /* no children */
  },
  {
    path: '/verify-telegram',
    name: '/verify-telegram',
    component: () => import('/home/runner/work/tt/tt/tt-fe/src/pages/verify-telegram.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

